import { Flex, Button, ModalV2, Text, toast } from "@jsq/ds/core";
import { useSetComplianceProgramMutation } from "~/graphql/supergraphHooks";
import { SPACING } from "~/styles/variables";
import { toGlobalId } from "~/utils/graphql-helpers";
import { ProgramsType } from "../types";

type Props = {
  allPrograms: ProgramsType;
  arenaId: string;
  entityId: string;
  entityName: string;
  showModal: boolean;
  oldValue: string;
  newValue: string;
  onClose: () => void;
};

const AssignProgramWarningModal = ({
  allPrograms,
  arenaId,
  entityId,
  entityName,
  showModal,
  oldValue,
  newValue,
  onClose,
}: Props) => {
  // Assuming `programs` is your list of all possible Program objects
  const selectedProgram = allPrograms?.find((program) => program.name === newValue);
  const oldProgram = allPrograms?.find((program) => program.name === oldValue);
  const [setComplianceProgramMutation] = useSetComplianceProgramMutation({
    refetchQueries: ["GetFilteredEntities"],
    onCompleted: () =>
      toast.success(`Successfully set compliance program for entity ${entityName}`),
    onError: (e) => toast.error(e.message),
  });

  const setComplianceProgram = async () => {
    await setComplianceProgramMutation({
      variables: {
        arenaId: toGlobalId("ArenaObjectType", arenaId),
        entityId: entityId,
        programString: selectedProgram?.name ?? "",
      },
    });
    onClose();
  };

  return (
    <ModalV2 show={showModal} onHide={onClose} isCentered={true} size="small" title="Warning">
      <Text>
        {`The compliance program for ${entityName} will be changed from ${oldProgram?.name ?? "--"} to ${selectedProgram?.name ?? "--"}`}
      </Text>
      <Text css={{ marginTop: SPACING.MEDIUM }}>
        Changing the compliance program for an entity will impact in-progress cases. Please be
        careful when changing the compliance program.
      </Text>
      <Flex
        justifyContent="flex-end"
        css={{ marginBottom: SPACING.MEDIUM, marginTop: SPACING.MEDIUM }}
      >
        <Button onClick={onClose} variant="neutral" css={{ marginRight: SPACING.MEDIUM }}>
          Cancel
        </Button>
        <Button onClick={setComplianceProgram} variant="primary">
          Change compliance program
        </Button>
      </Flex>
    </ModalV2>
  );
};

export default AssignProgramWarningModal;
